import "./stylenews.css";
import React, { useEffect, useState } from "react";
import {BackTop} from "antd"
import { RichText } from "../../components/richtext";
import { TopMenu } from "../../components/topmenu/TopMenu";
import { getNews } from "../../services/index";
import qs from "querystring";
export function NewsDetail(props) {
  const [fileinfo, setFileinfo] = useState(null);
  useEffect(() => {
    let params = null;
    let { search } = props.location;
    params = qs.parse(search.slice(1));
    if (!params) {
      getNews({
        news: {
          id: localStorage.newsId,
        },
      }).then((res) => {
        setFileinfo(res.data[0]);
      });
    } else {
      localStorage.setItem("newsId", params.fileid);
      getNews({
        news: {
          id: params.fileid,
        },
      }).then((res) => {
        setFileinfo(res.data[0]);
      });
    }
  }, []);
  return (
    <div className="news_detail_div">
      <div className="news_d_page">
        {fileinfo && <RichText fileinfo={fileinfo} />}
      </div>
      <TopMenu />
      <BackTop />
    </div>
  );
}
